const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');
const { BarHeader, ModalBody } = require('dibs-elements');
const OverlaySpinner = require('dibs-overlay-spinner');

const css = require('./ContactDealerRenderer.scss');

class MultiContactDealerModalRenderer extends React.Component {
    constructor() {
        super();
        this.isLoaded = false;
    }
    render() {
        const props = this.props;
        const { queryConfig, modalProps, getNewEnvironment, forceEnvironmentUpdate } = props;
        const { MultiRequestContactDealer } = modalProps.modalComponents;
        if (this.isLoaded) {
            return null;
        }

        return (
            <Relay.Renderer
                Container={MultiRequestContactDealer}
                environment={getNewEnvironment()}
                queryConfig={queryConfig}
                render={({ done, props: relayProps }) => {
                    if (done && relayProps) {
                        this.isLoaded = true;

                        const contactDealerProps = Object.assign({}, modalProps, relayProps, {
                            forceEnvironmentUpdate,
                        });

                        return <MultiRequestContactDealer {...props} {...contactDealerProps} />;
                    }

                    return (
                        <div>
                            <BarHeader title="Loading..." />
                            <ModalBody>
                                <OverlaySpinner
                                    additionalWrapperClasses={css.spinnerWrapper}
                                    position={'isRelative'}
                                />
                            </ModalBody>
                        </div>
                    );
                }}
            />
        );
    }
}

MultiContactDealerModalRenderer.propTypes = {
    queryConfig: PropTypes.object,
    modalProps: PropTypes.object,
    getNewEnvironment: PropTypes.func,
    forceEnvironmentUpdate: PropTypes.func,
};

module.exports = MultiContactDealerModalRenderer;



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/MultiContactDealerModalRenderer.jsx